import { Panel } from './ui/Controls';
import { useStore } from '@/state/store';

/**
 * Why the engine did what it did. Surfacing the reasoning is what makes the
 * output feel like a decision rather than a template — and it makes a wrong
 * decision debuggable instead of mysterious.
 */
export function RationalePanel() {
  const spec = useStore((s) => s.variants.find((v) => v.id === s.activeId) ?? null);
  const directive = useStore((s) => s.directive);

  if (!spec) return null;

  const notes = [...spec.rationale, ...(directive?.notes ?? [])];
  const seen = new Set<string>();
  const unique = notes.filter((n) => (seen.has(n) ? false : (seen.add(n), true)));

  return (
    <Panel title="Design decisions">
      <ul className="space-y-1.5">
        {unique.map((note, i) => (
          <li key={`${i}-${note.slice(0, 24)}`} className="flex gap-2">
            <span className="mt-[5px] h-1 w-1 shrink-0 rounded-full bg-accent" />
            <span className="text-[10px] leading-relaxed text-ink-300">{note}</span>
          </li>
        ))}
      </ul>
    </Panel>
  );
}
